import $Jq from "jquery";
export default function addHtmlAndBody(content){
    let html = content.replace(/rmthtml/g,"html");
    html = html.replace(/rmtbody/g,"body");
    return html
}